import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedTranslateModule } from '../app/shared-translate.module';
import { SpinnerModule } from '../app/spinner.module';
import { ConfirmMessageDialog } from './components/dialogs/confirm-message-dialog/confirm-message-dialog';

@NgModule({
  imports: [
    CommonModule,
    SharedTranslateModule,
    SpinnerModule
  ],
  declarations: [
    ConfirmMessageDialog
  ],
  entryComponents: [
    ConfirmMessageDialog
  ],
  exports: [
    ConfirmMessageDialog
  ]
})

export class ConfirmMessageDialogModule {
}
